<template>
  <b-container fluid class="p-0">
    <b-row>
      <b-col sm="12" md="5">
        <b-card no-body>
          <b-card-header header-class="dark-header">
            <span class="font-weight-bold text-white">Chat Support</span>
          </b-card-header>
          <b-card-body>
            <p>
              To start a chat with our support team:            </p>
            <p>
              Touch the chat icon at the bottom of this page OR Scan below QR code<span style="color: #20a8d7"> to chat with us in Whatsapp.</span>
            </p>
           
          </b-card-body>
          <b-container class="d-flex justify-content-center  pb-4">
            <img src="../../../public/img/qr-code_MENUPOLY_TS.png" width="300"/>
          </b-container>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="5" class="mt-5">
        <b-card no-body>
          <b-card-header header-class="dark-header">
            <span class="font-weight-bold text-white">Call Support</span>
          </b-card-header>
          <b-card-body>
            <p class="text-muted">
              Call MENUPOLY customer support at
              <span class="text-dark font-weight-bold">
                855-550-6368
              </span>
              for any technical issues or questions.
            </p>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <span v-if="availableFont">font roboto available</span>
        <span v-else>font roboto not available</span>
      </b-col>
    </b-row>
  </b-container>

</template>

<script>
import * as types from '@/store/types'
import {FontDetector} from './font'
export default {
  name: 'index',
  
  watch: {
    '$store.state.selectedRestaurantId': {
      handler: function(newVal) {
        //get clientId
        if (newVal) {
          this.GetRestaurantRestauranteurID(newVal)
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      Message: '',
      ClientID: null,
      showSuccess: false
      // src2: logo
    }
  },
  metaInfo() {
    return {
      title: 'Support'
    }
  },
  mounted() {
    // Check if Intercom script has already been loaded
    if (!window.Intercom) {
      // Load Intercom script dynamically if not already loaded
      const script = document.createElement('script');
      script.src = 'https://widget.intercom.io/widget/r5vlgzol';
      script.async = true;
      document.head.appendChild(script);
      script.onload = this.initializeIntercom;
    } else {
      this.initializeIntercom();
    }
  },
  beforeDestroy() {
    // Remove Intercom widget when component is unmounted
    window.Intercom('shutdown');
  },

    
    
  
  
  computed: {
    availableFont() {
      const d = new FontDetector()
      return d.detect('Roboto')
    }
  },

  methods: {
    initializeIntercom() {
      // Initialize Intercom with your app ID
      window.intercomSettings = {
        app_id: 'r5vlgzol', // Replace with your Intercom app ID
        name: localStorage.getItem("name") + " " + localStorage.getItem("lastName"),
        email: localStorage.getItem("Email"),
        user_id:localStorage.getItem("Email"),
        company: {
          id: localStorage.getItem("selectedRestaurant"),
          name: localStorage.getItem("selectedRestaurantName"),
      }
      };
      window.Intercom('boot', window.intercomSettings);
    },

    customerSupport() {
      //send form
      let object = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID'),
        ClientID: this.ClientID,
        Message: this.Message
      }

      if (this.Message === '' || this.Message === null) {
        this.$showError('The Message field is required')
      } else {
        this.$api.getRestaurant.CustomerSupport(object).then(res => {
          if (res.success) {
            this.showSuccess = true
          } else {
            this.$showError(res.message)
          }
        })
      }
    },
    GetRestaurantRestauranteurID(RestaurantID) {
      let object = {
        RestaurantID,
        // UserID: localStorage.getItem('userID')
      }
      this.$api.getRestaurant.GetRestaurantRestauranteurID(object).then(res => {
        if (res.success) {
          this.ClientID = res.results
        } else {
          this.$showError(res.message)
        }
      })
    },
    test(dataUrl) {
      console.log(dataUrl)
    }
  }
}
</script>

<style scoped>
/*@media print {*/
/*    @page {*/
/*        size: 75mm 100mm;*/
/*        margin: 0;*/
/*    }*/
/*}*/
</style>
